export default "__VITE_ASSET__BJl3j$yz__"